import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface EmailSettings {
  senderEmail: string;
  hasAppPassword: boolean;
}

export interface EmailSettingsRequest {
  senderEmail: string;
  appPassword?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class EmailSettingsService {
  private readonly apiUrl = environment.apiUrl + '/emailSettings';

  constructor(private readonly http: HttpClient) {}

  getSettings(): Observable<EmailSettings> {
    return this.http.get<EmailSettings>(
      this.apiUrl,
      { withCredentials: true }
    );
  }

  updateSettings(
    settings: EmailSettingsRequest
  ): Observable<void> {
    return this.http.put<void>(
      this.apiUrl,
      settings,
      { withCredentials: true }
    );
  }
}